var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 32,
    viewBox: "0 0 78 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H77.1213V28.7866H0V0Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9791 2.14226H2.14226V26.6444H74.9791V2.14226ZM0 0V28.7866H77.1213V0H0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0251 19.2803V8.03347H17.272V9.64017H9.23849V12.8536H15.6653V14.4603H9.23849V17.6736H17.272V19.2803H6.0251Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8787 19.2803V8.03347H28.5188V9.64017H30.1255V14.4603H28.5188V16.0669H22.0921V19.2803H18.8787ZM22.0921 14.4603H26.9121V9.64017H22.0921V14.4603Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3389 19.2803V8.03347H36.5523V17.6736H42.9791V19.2803H33.3389Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5858 19.2803V11.2469H46.1925V9.64017H47.7992V8.03347H52.6192V9.64017H54.2259V11.2469H55.8326V19.2803H52.6192V16.0669H47.7992V19.2803H44.5858ZM47.7992 14.4603H52.6192V11.2469H51.0126V9.64017H49.4059V11.2469H47.7992V14.4603Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2594 19.2803V14.4603H60.6527V12.8536H59.046V8.03347H62.2594V12.8536H65.4728V8.03347H68.6862V12.8536H67.0795V14.4603H65.4728V19.2803H62.2594Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.7866H77.1213V32H0V28.7866Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ec1aaacf9086198ceaa2b38667f61c7f.svg";
export { ForwardRef as ReactComponent };